export const style = /*css*/ `
    .p-picklist {
        display: flex;
        gap: dt('picklist.gap');
    }

    .p-picklist-controls {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: dt('picklist.controls.gap');
    }

    .p-picklist-list-container {
        flex: 1 1 50%;
    }

    .p-picklist .p-listbox {
        height: 100%;
    }
`;
